import { useNavigate } from 'react-router-dom'

import { useCallback, useEffect, useState } from 'react'

import styles from './styles.module.scss'

import { StorageService } from '@/services/storage'
import { useDownload } from '@/pages/@hooks/use-download'
import { Institution } from '../../../domain/entities/institution.entity'
import { InstitutionRepository } from '../../admin/repositories/institution.repository'

import { Scholar } from '@/Icons'
import { ToBePartner } from './to-be-partner'

interface IProps {
  category: string
}

const storageService = new StorageService()

export const Scholarships = ({ category }: IProps) => {
  const schoolCategories = [2, 5, 8, 9]

  const navigate = useNavigate()
  const [institutions, setInstitutions] = useState<Institution[]>([])

  const { download } = useDownload({ storageService })

  const getImage = async (filename: string) => {
    if (!filename) return null
    const [response] = await download(filename)
    return response.url
  }

  const categoryParagraph =
    {
      '2': 'Escolas com bolsa de estudos:',
      '3': 'Cursos com bolsa de estudos:',
      '4': 'Cursos com bolsa de estudos:',
      default: 'Faculdades com bolsa de estudos:',
    }[category || 'default'] || 'Faculdades com bolsa de estudos:'

  const fetchInstitutions = useCallback(async () => {
    setInstitutions([])

    const _institutions = await InstitutionRepository.GetInstance().list()

    const institutions_shuffled =
      _institutions
        ?.filter(
          (i) =>
            !!i &&
            i.Courses.some((c) => schoolCategories.includes(c.category_id)),
        )
        ?.sort(() => 0.5 - Math.random()) || []

    const slicedInstitutions = institutions_shuffled?.slice(0, 10) || []

    const promises = slicedInstitutions.map((i) =>
      i?.logo ? getImage(i.logo) : null,
    )

    const response = await Promise.all(promises)

    const data =
      slicedInstitutions.map((i, index) => ({
        ...i,
        logo: response?.[index] || '',
      })) || []

    setInstitutions(data)
  }, [])

  useEffect(() => {
    fetchInstitutions()
  }, [])

  return (
    <div className={styles.bigSquare}>
      <p className={styles.title}>{categoryParagraph}</p>
      <ToBePartner />
      <div className={styles.partners_school_container}>
        {institutions?.map((institution) => {
          const url = `/cursos/${institution.title}/${institution.id}/${category}`
          return (
            <div key={institution.id} className={styles.partners_school}>
              <div className={styles.image_container}>
                {institution?.logo && (
                  <img width={128} src={institution.logo} />
                )}
                {!institution?.logo && <Scholar size={80} />}
              </div>
              <p>{institution.title}</p>
              <button onClick={() => navigate(url)}>Ver Cursos</button>
            </div>
          )
        })}
      </div>
    </div>
  )
}
